import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "31",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "21.722",
      height: "21.722",
      x: ".639",
      y: "5.472",
      stroke: "currentColor",
      "stroke-width": "1.278",
      rx: "4.472"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.161 17.078H12.51v4.574h-2.147v-4.574h-4.65v-2.02h4.65v-4.6h2.147v4.6h4.651z"
    }, null, -1)
  ]))]))
}
export default { render: render }